var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.333,
    height: 68.333,
    viewBox: "0 0 68.333 68.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contact-us",
    transform: "translate(-0.833 -0.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M35,.833A34.167,34.167,0,1,1,.833,35,34.167,34.167,0,0,1,35,.833Zm0,6.833A27.333,27.333,0,1,0,62.333,35,27.333,27.333,0,0,0,35,7.667ZM46.251,22.334,28.167,40.418,23.749,36a3.417,3.417,0,0,0-4.832,4.832l6.833,6.833a3.417,3.417,0,0,0,4.832,0l20.5-20.5a3.417,3.417,0,0,0-4.832-4.832Z",
    fill: "#292F49",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact-us.f85302d37dd9edf30efa3b268b5a94d8.svg";
export { ForwardRef as ReactComponent };